// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import accountReducer from "./accountReducer";
import menuReducer from './slices/menu';
import transitionReducer from "./transitionReducer";
import cmsReducer from './cmsReducer';
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  
    auth: persistReducer(
        {
            key: 'user',
            storage,
            keyPrefix: 'panel-'
        },
        accountReducer
    ),
    snackbar: snackbarReducer,
    menu: menuReducer,
    transition:transitionReducer,
    cms:cmsReducer
});

export default reducer;
